// extracted by mini-css-extract-plugin
module.exports = {"remarksLabel":"style_remarksLabel__t9Cz2"};